import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';

@Injectable({
    providedIn: 'root'
})
export class TeamsService {
    private BASE_URL = environment.apiUrl + 'api';

    constructor(private http: HttpClient) { }

    getTeams(): Observable<any> {
        const url = `${this.BASE_URL}/team/all/teams`;
        return this.http.get<any>(url);
    }

    createTeam(teamData: any): Observable<any> {
        const url = `${this.BASE_URL}/team/create`;
        return this.http.post<any>(url, teamData);
    }

}
